export default __webpack_public_path__ + "static/media/professionalDetailshelpHighlight@2x.53f398e2.png";